import styled from 'styled-components';
import grey from 'sushiweb/tokens/color/grey';
import { NavLink } from 'react-router-dom';
import { P } from 'sushiweb/Typography/Text';
import red from 'sushiweb/tokens/color/red';

export const NavbarWrapper = styled.div`
  width: 27rem;
  height: calc(100vh);
  position: fixed;
  padding-left: 1rem;
  padding-right: 1rem;
  background: ${props =>
    props.isStagging ? red.z100 : 'var(--coolgreycoolgrey-100, #f2f4f7)'};
  border-right: 0.1rem solid ${grey.z200};
`;

export const StyledLink = styled(NavLink)`
  display: flex;
  align-items: center;
  height: 5.8rem;
  padding: 0rem 0rem 0rem 1.2rem;
  font-size: 1.5rem;
  text-decoration: none;
  border-left: 0.6rem solid transparent;
  margin-top: ${props => (props.isFirst ? '10px' : '0px')};
  p {
    margin-left: 1rem;
    color: var(--coolgreycoolgrey-900, #293142);
  }
  div {
    margin-top: 0.4rem;
    margin-right: 1rem;
    color: var(--coolgreycoolgrey-900, #293142);
    width: 20px;
  }
`;

export const StyledDiabledLink = styled.div`
  display: flex;
  align-items: center;
  height: 5.8rem;
  padding: 0rem 0rem 0rem 1.2rem;
  font-size: 1.5rem;
  text-decoration: none;
  border-left: 0.6rem solid transparent;
  p {
    margin-left: 1rem;
    color: var(--coolgreycoolgrey-500, #9197a6);
  }
  div {
    margin-top: 0.4rem;
    margin-right: 1rem;
    color: var(--coolgreycoolgrey-500, #9197a6);
    width: 20px;
  }
  path {
    fill: var(--coolgreycoolgrey-500, #9197a6);
  }
`;

export const BottomWrapper = styled.div`
  position: absolute;
  width: 100%;
  height: max-content;
  left: 0;
  bottom: 2.8rem;
`;

export const LogoutButton = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 2.8rem;
  background: var(--coolgreycoolgrey-50, #f8f9fc);
  color: var(--coolgreycoolgrey-900, #293142);
  font-size: 1.5rem;
  text-decoration: none;
  border-left: 0.6rem solid transparent;
  p {
    margin-left: 1.6rem;
    color: ${grey.z800};
  }
  &:hover {
    background: ${grey.z200};
  }
`;

export const StyledP = styled(P)`
  margin: 0.6rem 2rem 0 2.6rem;
  font-size: 1.2rem;
  color: ${grey.z500};
`;

export const ComingSoonDiv = styled.span`
  margin-left: 10px;
  margin-top: 2px;
  padding: 3px;
  padding-left: 6px;
  padding-right: 6px;
  border: 0.5px solid ${grey.z100};
  border-radius: 5px;
  background: var(--basewhite-000, #fff);
  color: ${grey.z700};
  text-align: center;
  font-size: 9px;
  font-style: normal;
  font-weight: 500;
  text-transform: uppercase;
  span {
    padding-left: 2px;
    padding-right: 2px;
  }
`;

export const ZFELogoWrapper = styled.div`
  background: ${props =>
    props.isStagging ? red.z100 : 'var(--coolgreycoolgrey-100, #f2f4f7)'};
  margin: 2rem;
`;
